// src/assets/standard-events-loader.js
//
// Charge la librairie officielle "Shopify Standard Storefront Events" depuis le
// CDN et l'expose sur window.Shopify.StandardEvents.
//
// Le thème est bundlé par Vite (pas d'importmap runtime) : on ne peut pas
// importer la lib CDN directement dans le bundle. On la charge donc via ce
// module <head> non bundlé (stratégie "global loader" de la doc Shopify), puis
// le code du thème y accède de façon paresseuse via window.Shopify.StandardEvents.
//
// Toute consommation doit être gardée (`window.Shopify?.StandardEvents?.…`) car
// ce module se résout de manière asynchrone (import réseau).
import * as StandardEvents from "https://cdn.shopify.com/storefront/standard-events.js";

window.Shopify = window.Shopify || {};
window.Shopify.StandardEvents = StandardEvents;

// Élément déclaratif <s-view-event> : lit `view-event-payload` (rendu serveur par
// le filtre standard_event_data) et dispatche le view event au bon moment
// (view-event-trigger : connect | intersect | dialog). Utilisé pour product:view,
// collection:view et cart:view niveau page.
if (
  typeof StandardEvents.createViewEventElement === "function" &&
  !customElements.get("s-view-event")
) {
  customElements.define(
    "s-view-event",
    StandardEvents.createViewEventElement()
  );
}

// Signal pour les rares cas où un consommateur doit attendre la disponibilité.
window.dispatchEvent(new CustomEvent("shopify:standard-events:ready"));
